<script>
    export default {
        name: "MaterialInput",
        props: {
            label: String,
            value: String,
            type: String,
            readonly: String,
        },

        computed: {
            inputListeners() {
                var vm = this;
                return Object.assign({}, this.$listeners, {
                    input(event) {
                        vm.$emit("input", event.target.value);
                    }
                });
            }
        },

        data() {
            return {
                focused: false,
                val: this.value
            };
        },

        watch: {
            value(newVal) {
                // update our internal val when it's changed externally (happens sometimes)
                this.val = newVal;
            }
        }
    };
</script>



<template>
    <div class="material-input">
        <div class="input-container" :class="{focused}">
            <input v-if="(type || 'text') == 'text'" type="text" autocomplete="none" :readonly="readonly"
                v-model="val" v-on="inputListeners" @focus="focused = true" @blur="focused = false" :bind="$attrs">

            <input v-if="type == 'password'" type="password" :readonly="readonly"
                v-model="val" v-on="inputListeners" @focus="focused = true" @blur="focused = false" :bind="$attrs">

            <slot></slot>
        </div>

        <span class="bar"></span>
        <label :class="{above: focused || (val || '').length > 0}">
            {{ label }}
        </label>
    </div>
</template>


<style lang="scss">
    .material-input {
        $input-padding: 18px 12px;

        position: relative;
        margin-bottom: 45px;
        display: block;

        .input-container {
            display: flex;
            border-bottom: 1px solid #aaa;
            background: #f6f6f6;
            border-radius: 4px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            &.focused {
                border-bottom: 1px solid $input-accent-color;
            }
        }

        input {
            flex-grow: 1;
            background: transparent;
            font-size: 18px;
            padding: $input-padding;
            padding-top: 28px;
            padding-bottom: 6px;
            border: none;

            &:focus {
                outline: none;
            }
        }

        label {
            color: #999;
            font-size: 18px;
            font-weight: normal;
            position: absolute;
            pointer-events: none;
            transition: 0.2s ease all;
            padding: $input-padding;
            top: 0;
            left: 0;

            &.above {
                font-size: 0.8em;
                top: 6px;
                left: 8px;
                color: $input-accent-color;
                padding: 1px 4px;
            }
        }

        .bar {
            position: absolute;
            display: block;
            width: 100%;

            &:before,
            &:after {
                content: "";
                height: 2px;
                width: 0;
                bottom: 0;
                position: absolute;
                background: $input-accent-color;
                transition: 0.2s ease all;
            }
            &:before {
                left: 50%;
            }
            &:after {
                right: 50%;
            }
        }

                /* active state */
        input:focus ~ .bar:before,
        input:focus ~ .bar:after {
            width: 50%;
        }

    }
</style>
